import { ReactNode } from 'react';
import { ThemeProvider } from './ThemeProvider';
import { VoiceProvider } from './VoiceProvider';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="chessmaestro-theme">
      <VoiceProvider>
        {children}
      </VoiceProvider>
    </ThemeProvider>
  );
}
